import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import type { ReportDetails } from "@memorang/types";
import type { GetReportRequest } from "./types";

export async function getReport(
	request: GetReportRequest,
): Promise<ReportDetails> {
	const { data } = await authAxios.post<{ data: ReportDetails }>(
		`${API_BASE_URL}/session/reports`,
		request,
	);
	return data.data;
}
